import React from 'react';
import { isNotDefined } from '@togglecorp/fujs';
import { genericMemo } from '../../../utils/index.js';

function Cell(props) {
  const {
    className,
    value,
    tooltip
  } = props;

  if (isNotDefined(value)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: className,
    title: tooltip ?? undefined
  }, value);
}

var Cell$1 = genericMemo(Cell);

export { Cell$1 as default };
//# sourceMappingURL=index.js.map
